import throttleAsyncFunction from "@/client/utilities/throttleAsyncFunction.js";
import getAsyncOps from "@/client/extensions/composition/asyncOperations.js";
import { helpers } from "@vuelidate/validators";
import { watch } from "vue";
export default function (options = {}) {
  let debounce = null;
  let lastPromiseResolver = null;
  let store = options.store || false;
  let validator = (value) => {
    let runValidator = async (resolveCb, rejectCb) => {
      if (!value && value !== 0 && value !== false) {
        return resolveCb(true);
      }

      let requestResult;

      try {
        let requestData = {
          type: options.type,
          key: options.key,
          value: value,
        };

        let extractExcludeValueFromContext = () => {
          let excludeValue = undefined;

          // look for exclude value
          if (options.excludeIdKey && options.context) {
            if (
              typeof options?.context?.validationContext === "object" &&
              options?.context?.validationContext[options.excludeIdKey]
            ) {
              excludeValue = options.context.validationContext[options.excludeIdKey];
            }

            if (
              options?.context?.form?.formData &&
              typeof options?.context?.form?.formData === "object" &&
              options?.context?.form?.formData[options.excludeIdKey]
            ) {
              excludeValue = options.context.form.formData[options.excludeIdKey];
            }
          }
          return excludeValue;
        };
        let excludeValue = extractExcludeValueFromContext();

        if (excludeValue) {
          requestData.exclude = excludeValue;
        }

        if (options && options.valueParser) {
          requestData.value = await options.valueParser(requestData.value, options);
        }

        requestResult = await getAsyncOps({}, store).asyncCall(
          "entity/validation/is-unique",
          requestData,
          {}
        );

        if (requestResult.hasError) {
          warn(
            "unique value validation - error while checking value. returning hard coded true"
          );
          resolveCb(true);
        }

        // exists -> validation fails
        resolveCb(!requestResult.data?.exists);
      } catch (e) {
        rejectCb(false);
      }
    };

    // this is the wrapper around the validator. it will only run it once per interval
    // a fast subsequant call makes the older one return true, abourts the schedule running of the validator
    // and queues the validator to run
    return new Promise(async (resolve, reject) => {
      // when this runs, resolve the "older ones"
      if (lastPromiseResolver && typeof lastPromiseResolver === "function") {
        lastPromiseResolver(true);
      }

      lastPromiseResolver = resolve;

      let intervalLength = 1000;
      if (typeof options  === 'object' && options && options?.interval ) {
        intervalLength = options.interval;
      }
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        await runValidator(resolve, reject);
      }, intervalLength);
    });
  };

  return helpers.withParams({ type: "uniqueValue" }, helpers.withAsync(validator));
}
